import { GetTablesToModelArgs } from './model';

export const getTablesToModel = ({
  destinations,
  model,
}: GetTablesToModelArgs): string[] => {
  let tables: string[] = [];
  destinations?.forEach((destination) => {
    const chosenTables = destination.chosenTables.find(
      (tables) => tables.modelName === model.name
    );

    if (chosenTables) {
      tables = chosenTables.tables;
      return;
    }
  });

  return tables;
};
